/* eslint-disable prefer-template */
import React from 'react';
import PropTypes from 'prop-types';

const toggleFilter = (type) => {
    const parentElement = document.getElementById(`filterDropdown-${type}`);
    if(parentElement.className.includes('closed')) {
        parentElement.className = 'sideBar__search--dropdown';
    } else {
        parentElement.className = 'sideBar__search--dropdown closed';
    }
}

const LocationFilter = ({options, selected, type, handleChange}) => (
        <div className={`sideBar__search--dropdown ${selected.length > 0 ? '' : 'closed'}`} id={`filterDropdown-${type}`}>
            <button className="sideBar__search--dropdownButton" onClick={() => toggleFilter(type)}>
                <span>{type[0].toUpperCase() + type.substring(1)}</span>
                <span className="fas fa-chevron-down"/>
            </button>

            <div className="sideBar__search--dropdownItems">
                {Object.keys(options).map(key => (
                    <div className="sideBar__search--dropdownGroup" key={key}>

                        <span className="sideBar__search--dropdownGroupTitle">{key}</span>

                        {options[key].map(option => (
                            <div key={option} className="sideBar__search--dropdownItem">
                                <input 
                                    className="sideBar__search--dropdownInput"
                                    type="checkbox"
                                    checked={selected.includes(option)}
                                    id={`dropdownOption--${option}`} 
                                    name={option} 
                                    value={option} 
                                    onClick={(e) => {
                                        if(e.target.checked) {
                                            handleChange(option, `${type}Filter`)
                                        } else {                                
                                            handleChange(option, `${type}Filter`, true)
                                        }
                                    }}
                                />
                                <label htmlFor={`dropdownOption--${option}`}>{option}</label>
                            </div>
                        ))}

                    </div>
                ))}
            </div>
        </div>
);


LocationFilter.propTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    options: PropTypes.object.isRequired,
    // eslint-disable-next-line react/forbid-prop-types
    selected: PropTypes.object,
    type: PropTypes.string.isRequired,
    handleChange: PropTypes.func.isRequired
};

LocationFilter.defaultProps = {
    selected: []
};

export default LocationFilter;



// WEBPACK FOOTER //
// ./frontend/components/Jobs/LocationFilter.jsx